import { firestoreAction } from 'vuexfire'
import { db } from '@/plugins/firebase'
import {ga} from '@/main'

const state = {
    usersRef: {},
    contacts: [],
}
const mutations = {
    REFRESH_USER_REFS: function (state) {
        state.usersRef = { ...state.usersRef }
    }
}
const actions = {
    bindContacts: firestoreAction(async ({ bindFirestoreRef, rootState, dispatch }) => {
        await bindFirestoreRef('contacts', db.collection("contacts").where("between", "array-contains", rootState.db.user.id));
        await dispatch("refreshUsersRef");
    }),
    refreshUsersRef: firestoreAction(async ({ bindFirestoreRef, getters, commit, rootState }) => {
        let bind = async (l) => {
            await Promise.all(l.filter(uid => !state.usersRef[uid]).map(async uid => await bindFirestoreRef('usersRef.' + uid, db.collection("users").doc(uid))));
        }
        let fromConversations = [...new Set(rootState.conversations.conversations.flatMap(c => c.between))];
        await Promise.all([bind(getters.getContacts), bind(getters.getRequests), bind(fromConversations)]);
        commit("REFRESH_USER_REFS");
    }),
    searchUser: async function ({ }, pseudo) {
        let response = await db.collection('users').where("displayName", "==", pseudo).get();
        let uid = response.docs.length == 1 ? response.docs[0].id : false;
        if (uid) return uid
        else return false
    },
    addContact: firestoreAction(async function ({ bindFirestoreRef, rootState, getters, commit }, uid) {
        let alreadyRequested = getters.searchContact(uid);

        if (alreadyRequested) {
            let duplicate = alreadyRequested.needsToAccept.length > 0 && alreadyRequested.needsToAccept[0] !== rootState.db.user.id;
            if (duplicate) return false;

            await db.collection("contacts").doc(alreadyRequested.id).update({
                ...alreadyRequested,
                needsToAccept: [],
                acceptedTime: Date.now()
            })
            ga.event("Social","accept_contact_request");
        } else {
            await db.collection("contacts").add({
                between: [rootState.db.user.id, uid],
                needsToAccept: [uid],
                askedTime: Date.now()
            }),
            await bindFirestoreRef('usersRef.' + uid, db.collection("users").doc(uid));
            commit("REFRESH_USER_REFS");
            ga.event("Social","send_contact_request");
        }
        
    }),
    removeContact: async function ({ getters }, uid) {
        let contact = getters.searchContact(uid);
        await db.collection("contacts").doc(contact.id).delete();
        ga.event("Social","remove_contact");
    },
    deleteAllContacts: async function({state}){
        await Promise.all(state.contacts.map(async doc => await db.collection("contacts").doc(doc.id).delete()))
    }
}
const getters = {
    searchContact: state => uid => {
        return state.contacts.find(c => c.between.includes(uid));
    },
    getContacts: (state, getters, rootState) => state.contacts.filter(c => c.needsToAccept.length == 0).map(c => c.between.find(uid => uid != rootState.db.user.id)),
    getRequests: (state, getters, rootState) =>
        state.contacts
            .filter(c => c.needsToAccept.length == 1 && c.needsToAccept[0] === rootState.db.user.id)
            .map(c => c.between.find(uid => uid != rootState.db.user.uid))
}

export default {
    state,
    mutations,
    actions,
    getters
}